import * as colors from './colors';

export const gray = `1px solid ${colors.gray}`;
export const black = `1px solid ${colors.black}`;
export const yellow = `1px solid ${colors.yellow}`;
export const blue = `2px solid ${colors.blue}`;
export const midblack = `1px solid ${colors.blackOpacity5}`;
export const grayOpacity = `1px solid ${colors.darkestGrayOpacity5}`;
